import { clsx } from 'external/clsx'
import {CSSProperties, FC} from 'external/react'

type BadgeCounterProps = {
    count: number
    label: string
    plural?: string
    className?: string
    style?: CSSProperties,
    hideAtZero?: boolean
}

const BadgeCounter: FC<BadgeCounterProps> = props => {
    const {count, label, hideAtZero = true} = props
    const plural = props.plural || `${label}s`
    return (
        <span className={clsx('badge', 'text-bg-light', 'border mr-1', {'d-none': hideAtZero && count == 0})} style={{ fontSize: '10px' }}>
            {count}{` ${count === 1 ? label : plural}`}
        </span>
    )
}

export {BadgeCounter as default}